import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit, OnChanges {
  @Input() pageName: string = '';
  @Input() routePath: string = '';
  @Output() event: any = new EventEmitter();
  @Input() breadCrumbs: any = [];
  @Output() isDrill: any = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('Changes: ', changes);
  }

  emitEvent() {
    this.event.emit('Back Event');
  }

  isBack() {
    if (this.breadCrumbs.length > 0) {
      this.breadCrumbs.pop();
      this.isDrill.emit(this.breadCrumbs);
    } else {
      this.isDrill.emit([]);
    }
  }
}
